// Workers are messaged through the managd app (a push notification). Numbers typed in
// by hand belong to people outside the app, such as a site supervisor, and are sent a
// real SMS. Only about a third of workers have the app, so every message dialog shows
// who can receive it, and the result says exactly who did.
export const MESSAGE_LIMIT = 180 // the app notification shows no more than this

// Mirrors normalizePushTokens in functions/index.js.
export const hasApp = worker => [
    ...(Array.isArray(worker?.expoPushTokens) ? worker.expoPushTokens : []),
    worker?.expoPushToken, worker?.pushToken, worker?.notificationToken,
].filter(Boolean).map(token => String(token).trim()).some(token => /^Expo(nent)?PushToken\[.+\]$/.test(token)) || worker?.hasApp === true

const count = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`

// Whether a send reached anyone. When it reached nobody, the dialog stays open with
// the message so the admin can fix the recipients and try again.
export const reachedAnyone = result => typeof result === 'string'
    || ((result?.sentToApp?.length || 0) + (result?.texted?.length || 0)) > 0

// Turns the send result into the confirmation shown to the admin.
export function describeMessageResult(result, nameOf = id => id) {
    // Before the functions deploy that reports reach, the server replies with the text
    // 'Message Sent'. The send worked; there is just no breakdown, so say only that.
    if (typeof result === 'string') return { title: 'Message sent', message: 'Message sent.' }
    const { sentToApp = [], appFailed = [], withoutApp = [], notFound = [], texted = [], textFailed = [] } = result || {}
    const reached = sentToApp.length + texted.length
    const missed = appFailed.length + withoutApp.length + notFound.length + textFailed.length
    const lines = []
    if (sentToApp.length) lines.push(`Sent to ${count(sentToApp.length, 'worker')} in the managd app.`)
    if (texted.length) lines.push(`Texted ${count(texted.length, 'number')}.`)
    if (appFailed.length) lines.push(`Not delivered to ${appFailed.map(nameOf).join(', ')}: their managd app could not be reached. They may need to open the app and sign in again.`)
    if (withoutApp.length) lines.push(`Not received by ${withoutApp.map(nameOf).join(', ')}: no managd app.`)
    if (notFound.length) lines.push(`${count(notFound.length, 'worker')} could not be found and ${notFound.length === 1 ? 'was' : 'were'} not messaged.`)
    if (textFailed.length) lines.push(`Text could not be sent to ${textFailed.join(', ')}.`)
    return {
        title: !reached ? 'Message not sent' : missed ? 'Message partly sent' : 'Message sent',
        message: lines.join(' ') || 'Nobody could be reached.',
    }
}
